import posthog from "posthog-js";
import { initErrorReporting } from "@freightsimple/observability/errorReporting";
import { isProduction } from "@/Environment";
import { BROWSER_NETWORK_ERROR } from "./browserNetworkError";

// Run after initializePostHog: the PostHog integration links each Sentry error
// to the session recording, so Sentry needs no replay of its own.
export function initializeErrorReporting(): void {
  if (!isProduction()) {
    return;
  }

  initErrorReporting({
    dsn: "https://a3a550e4aa1e7359ef7ace33fb0f8184@o444510.ingest.us.sentry.io/4508357143560192",
    environment: "production",
    ignoreErrors: [BROWSER_NETWORK_ERROR],
    integrations: [
      posthog.sentryIntegration({
        organization: "freightsimple",
        projectId: 4508357143560192,
        // Errors live in Sentry only; PostHog just records the session.
        sendExceptionsToPostHog: false,
      }),
    ],
  });
}
